import { render } from "./Select.vue?vue&type=template&id=68bad64c"
import script from "./Select.vue?vue&type=script&setup=true&lang=js"
export * from "./Select.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Filter/Types/Select.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68bad64c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68bad64c', __exports__)) {
    api.reload('68bad64c', __exports__)
  }
  
  module.hot.accept("./Select.vue?vue&type=template&id=68bad64c", () => {
    api.rerender('68bad64c', render)
  })

}


export default __exports__